// src/components/Signup.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Signup() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { signup } = useAuth();
  const { language } = useLanguage();
  const isFr = language === "fr";
  const t = (frText, enText) => (isFr ? frText : enText);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signup(email, password, fullName);
      navigate("/", { replace: true });
    } catch (err) {
      setError(t("Impossible de créer votre compte. Essayez une autre adresse e-mail.", "Could not create your account. Try a different email."));
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-slate-950 bg-mesh-gradient px-4 py-16">
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_bottom,transparent,rgba(2,6,23,0.9))]" />
      <form onSubmit={handleSubmit} className="relative ui-panel w-full max-w-md space-y-5 p-8 sm:p-10">
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-indigo-600 text-sm font-bold text-white shadow-glow">
            AT
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-white">{t("Créer un compte", "Create account")}</h1>
          <p className="mt-2 text-sm text-slate-500">{t("Un compte unique pour une navigation personnalisée.", "One account for personalized browsing.")}</p>
          <div className="mt-3 flex justify-center">
            <LanguageSwitcher />
          </div>
        </div>
        {error ? (
          <p className="rounded-lg border border-rose-900/50 bg-rose-950/30 px-3 py-2 text-sm text-rose-200">{error}</p>
        ) : null}
        <div className="space-y-2">
          <label htmlFor="signup-name" className="text-xs font-medium text-slate-400">
            {t("Nom complet", "Full name")}
          </label>
          <input
            id="signup-name"
            type="text"
            autoComplete="name"
            required
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="ui-input"
            placeholder="Jean Dupont"
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="signup-email" className="text-xs font-medium text-slate-400">
            {t("E-mail", "Email")}
          </label>
          <input
            id="signup-email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="ui-input"
            placeholder="you@example.com"
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="signup-password" className="text-xs font-medium text-slate-400">
            {t("Mot de passe", "Password")}
          </label>
          <input
            id="signup-password"
            type="password"
            autoComplete="new-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="ui-input"
            placeholder={t("Au moins 6 caractères", "At least 6 characters")}
          />
        </div>
        <button type="submit" className="ui-btn-primary w-full py-3 text-base">
          {t("S'inscrire", "Register")}
        </button>
        <p className="text-center text-sm text-slate-500">
          {t("Déjà inscrit ?", "Already registered?")}{" "}
          <Link to="/login" className="font-medium text-brand-400 hover:text-brand-300">
            {t("Se connecter", "Sign in")}
          </Link>
        </p>
      </form>
    </div>
  );
}
